.card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: none;
  padding: 12px 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-card);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.title {
  font-size: var(--font-size);
  font-weight: 500;
}

.hint {
  margin-top: -4px;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

.error {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  color: var(--danger);
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton span {
  height: 14px;
  border-radius: 6px;
  background: var(--surface-muted);
  animation: pulse 1.4s ease-in-out infinite;
}

.skeleton span:nth-child(2) {
  width: 80%;
}

.skeleton span:nth-child(3) {
  width: 55%;
}

@keyframes pulse {
  50% {
    opacity: 0.45;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton span {
    animation: none;
  }
}
